var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide"},[_c('slide-verify',{ref:"slideblock",attrs:{"l":42,"r":10,"w":310,"h":155,"slider-text":_vm.text},on:{"success":_vm.onSuccess,"fail":_vm.onFail,"refresh":_vm.onRefresh}}),_c('div',[_vm._v(_vm._s(_vm.msg))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }